import React from "react";
import ls from "local-storage";
import config from "../constants/config";
import { grids } from "../selectors/index";

/* global device:readonly */
export const getPlatform = () =>
  typeof device !== "undefined" && device.platform
    ? device.platform
    : "browser";
// console.log("ls grids", ls("grids"));

export const isValidEq = (eq, grid) => {
  const numbers = eq.filter(Number);

  // check all numbers are tiles in the grid
  if (numbers.some((n) => grid.indexOf(n) < 0)) return false;

  // No duplicate numbers
  if (
    numbers.length !== numbers.filter((n, i) => numbers.indexOf(n) === i).length
  )
    return false;

  // Check all even positions are numbers
  if (!eq.filter((a, i) => i % 2 === 0).every(Number)) return false;

  // Check all odd positions are operators
  if (
    eq
      .filter((a, i) => i % 2 === 1)
      .some((o) => config.operators.indexOf(o) < 0)
  )
    return false;

  return true;
};

// const getEq = state => state.eq.slice(0, state.eqPos);

export const getTotal = (a) => {
  let rt = a[0] || 0;

  for (let i = 1; i + 1 < a.length; i += 2) {
    if (a[i] === "×") rt *= a[i + 1];
    if (a[i] === "÷") rt /= a[i + 1];
    if (a[i] === "+") rt += a[i + 1];
    if (a[i] === "-") rt -= a[i + 1];
  }
  return rt;
};

export const formatEq = (eq) => {
  const lines = [];

  if (eq.length === 0) return [];

  lines.push(<li key={0}>{eq[0]}</li>); // first number by itself

  for (let i = 1; i + 1 < eq.length; i += 2) {
    lines.push(
      <li key={i}>
        {eq.slice(i, i + 2).join(" ")} = {getTotal(eq.slice(0, i + 2))}
      </li>
    );
  }
  return (
    <div>
      <ul className="fullcalc">{lines}</ul>
      <div className="onelinecalc">
        {eq.join(" ")} = <strong>{getTotal(eq)}</strong>
      </div>
    </div>
  );
};
/*
export const getAchievementCount = solutions =>
  config.achievements.filter(a => solutions.some(a.check)).length;
*/
// Standardise an equation for comparing so that 4 x 5 + 6 - 7 is the same as 5 x 4 - 7 + 6
export const standardEq = (e) => {
  if (e.length <= 1) return e;
  let standard = [];
  let currentOp = "+";
  let group = [];
  const eq = e.slice();
  eq.unshift("×");
  eq.unshift("1");
  eq.unshift("+");
  eq.push("!");
  eq.push(0);

  for (let i = 0; i + 1 < eq.length; i += 2) {
    if (
      !(["+", "-"].indexOf(eq[i]) >= 0 && ["+", "-"].indexOf(currentOp) >= 0) &&
      !(["×", "÷"].indexOf(eq[i]) >= 0 && ["×", "÷"].indexOf(currentOp) >= 0)
    ) {
      // standard = standard.concat([].concat.apply([],
      // group.slice().sort().map(a => [ a.substr(-1), a.substr(0,a.length-1) ])));
      standard = [
        ...standard,
        ...group
          .slice()
          .sort()
          .map((a) => [a.substr(-1), a.substr(0, a.length - 1)]),
      ];
      group = [];
    }
    group.push("0".repeat(5 - eq[i + 1].toString().length) + eq[i + 1] + eq[i]);
    currentOp = eq[i];
  }

  return standard;
};

export const uniqueSolutions = (a) => {
  const standard = a.map((n) => standardEq(n).join(" "));

  return a.filter(
    (elem, pos) => standard.indexOf(standardEq(elem).join(" ")) === pos
  );
};

export const gridSizeTiles = (s) =>
  parseInt(s.substr(0, 1), 10) * parseInt(s.substr(-1), 10);

export const hasAchieved = (achievement, solutions, target, grid) =>
  solutions.some((eq) => achievement.check(eq, target, grid, solutions));

export const getStoredData = (grid) => {
  // const d = JSON.parse(localStorage.getItem(grid));
  // console.log("getStoredData localStorage", d);
  // console.log("getStoredData ls", ls(grid));
  const d = ls(grid);
  if (d && d.solutions && d.solutions.length > 0) return d;
  return { solutions: [] }; // default data
};
export const setStoredData = (grid, data) => {
  // console.log("setting data", grid, data);
  ls.set(grid, data);
  ls.set("currentGrid", grid);
  if ((ls("grids") || []).indexOf(grid) < 0) {
    // console.log("NEW GRID");
    ls.set("grids", [...(ls("grids") || []).filter((g) => g !== grid), grid]);
    grids.push(grid);
  }
  // console.log('testing set data', localStorage.getItem(grid));
};
export const getOldGridList = () =>
  Object.keys(localStorage)
    .filter((text) =>
      /^[\],:{}\s]*$/.test(
        text
          .replace(/\\["\\/bfnrtu]/g, "@")
          .replace(
            /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?/g,
            "]"
          )
          .replace(/(?:^|:|,)(?:\s*\[)+/g, "")
      )
    )
    .filter((a) => ls(a).solutions);

export const checkGridData = () => {
  // console.log("checkGD", ls("grids"));
  if (!ls("grids")) {
    ls.set("grids", getOldGridList());
  }
};
export const getGridData = () => {
  return ls("grids") || getOldGridList() || [];
};

export const findFactors = (n) => {
  const numFactors = [];

  for (let i = 1; i <= Math.floor(Math.sqrt(n)); i += 1) {
    if (n % i === 0) {
      numFactors.push(i);
      if (n / i !== i) numFactors.push(n / i);
    }
  }
  numFactors.sort((x, y) => x - y);
  return numFactors;
};
const findFactorSolution = (tiles, target) => {
  if (!Number.isInteger(target)) return [];
  // console.log('find factors', tiles, target);
  const f = findFactors(target).filter(
    (a) => a !== 1 && a !== target && tiles.indexOf(a) >= 0
  );
  // console.log('matching factors', target, f, f.map(a => (target / a)));
  return f;
};
const findOtherSolution = (tiles, target) => {
  // find any 2 tiles with any op
  const sols = [];
  tiles.forEach((t1) => {
    tiles
      .filter((t) => t !== t1)
      .forEach((t2) => {
        config.operators.forEach((o) => {
          if (getTotal([t1, o, t2]) === target) sols.push([t1, o, t2]);
          else {
            tiles
              .filter((t) => t !== t1 && t !== t2)
              .forEach((t3) => {
                config.operators.forEach((o2) => {
                  if (getTotal([t1, o, t2, o2, t3]) === target)
                    sols.push([t1, o, t2, o2, t3]);
                });
              });
          }
        });
      });
  });
  // console.log('fOS', tiles, target, sols);
  return sols;
};
// '+', '-', '×', '÷']

const opOp = (op) => {
  if (op === "×") return "÷";
  if (op === "÷") return "×";
  if (op === "+") return "-";
  return "+";
};

const findAllFactorSolution = (tiles, target) => {
  const solutions = [];
  findFactorSolution(tiles, target).forEach((s) => {
    findOtherSolution(
      tiles.filter((t) => t !== s),
      target / s
    ).forEach((ss) => {
      // (A +-*/ B) * C
      solutions.push([...ss, "×", s]);
    });
  });
  findOtherSolution(tiles, target).forEach((sol) => {
    // (A +-*/ B)
    solutions.push(sol);
  });

  // getTotal
  /*
  tiles.forEach((t, i) => {
    config.operators.forEach((o) => {
      findOtherSolution(
        [...tiles.slice(0, i), ...tiles.slice(i + 1)],
        getTotal([target, o, t]),
      ).forEach((sol) => {
        console.log('BLAH!!!!', sol);
        // looking for (a + b) = total - c
        // Same as above?
        // solutions.push(sol);
      });
      findFactorSolution(
        [...tiles.slice(0, i), ...tiles.slice(i + 1)],
        getTotal([target, o, t]),
      ).forEach((s) => {
        console.log('sol2', [(getTotal([target, o, t]) / s), '×', s, opOp(o), t].join(' '));
      });
    });
  });
  */
  return solutions;
};

export const findSolutions = (tiles, target) => {
  const bestmultSort = (a, b) => a.length - b.length;

  let solutions = findAllFactorSolution(tiles, target);

  config.operators.forEach((o) => {
    tiles.forEach((t) => {
      solutions = [
        ...solutions,
        ...findAllFactorSolution(
          tiles.filter((tile) => tile !== t),
          getTotal([target, o, t])
        ).map((s) => [...s, opOp(o), t]),
      ];
    });
  });

  solutions = solutions.sort(bestmultSort);
  // Remove duplicates
  solutions = uniqueSolutions(solutions.slice(0, 20));

  /*
  console.log(`Target: ${target}, Tiles: ${tiles}`);
  console.log('Factors', findFactors(target));
  for (let i = 0; i < Math.min(15, solutions.length); i += 1) {
    console.log(`${solutions[i].join(' ')} = ${getTotal(solutions[i])}`);
  }
  */
  return solutions;
};
export const formatTotal = (t) => {
  return t
    .toFixed(3)
    .replaceAll("0", " ")
    .trim()
    .replaceAll(" ", "0")
    .replaceAll(".", " ")
    .trim()
    .replaceAll(" ", ".");
};
export const shuffle = (a) => {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};
// export const VALID_HASH_CHARS =
//   "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-._~!$&'()*+,;=:@/?";
// export const VALID_HASH_CHARS =
//   "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-._~!$&'()*+,;=:@/?";
export const VALID_HASH_CHARS =
  "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_~$&'*+=:@/?";
export const getGridDiff = (grid) => {
  const sorted = [...grid].sort((a, b) => a - b);
  return sorted.map((a, ai) => (ai > 0 ? a - sorted[ai - 1] : a));
};
export const getGridBiggestDiff = (grid) => Math.max(...getGridDiff(grid));

const SWAP_CHARS = [
  "cbc",
  "bdb",
  "dbb",
  "bcc",
  "ccb",
  "bbd",
  "bcb",
  "cbb",
  "bbc",
  "bbb",
];
export const convertGameToHash = (game) => {
  // VALID_HASH_CHARS
  const t =
    VALID_HASH_CHARS[Math.floor(game.target / VALID_HASH_CHARS.length)] +
    VALID_HASH_CHARS[game.target % VALID_HASH_CHARS.length];
  const grid = getGridDiff(game.grid).map((a) => VALID_HASH_CHARS[a]);

  const checksum =
    VALID_HASH_CHARS[
      (game.grid.reduce((a, b) => a + b, 0) + game.target) %
        VALID_HASH_CHARS.length
    ];

  let out = grid.join("") + t + checksum;

  SWAP_CHARS.forEach((c, i) => {
    out = out.replaceAll(c, i);
  });

  return out;
};
export const convertHashToGame = (h) => {
  let hash = h;

  SWAP_CHARS.forEach((c, i) => {
    hash = hash.replaceAll(i, c);
  });
  const checksum = hash.substr(-1);
  const targetHash = hash
    .substr(-3, 2)
    .split("")
    .map((a) => VALID_HASH_CHARS.indexOf(a));
  const gridDiffs = hash
    .substr(0, hash.length - 3)
    .split("")
    .map((a) => VALID_HASH_CHARS.indexOf(a));
  const grid = [];
  gridDiffs.forEach((a, ai) => {
    grid[ai] = a + (ai > 0 ? grid[ai - 1] : 0);
  });
  const target = targetHash[0] * VALID_HASH_CHARS.length + targetHash[1];

  // gridDiffs.map((a, ai) => a + (ai > 0 ? gridDiffs[ai - 1] : 0));
  const game = { target, grid: shuffle(grid) };

  const checksumCorrect =
    VALID_HASH_CHARS[
      (game.grid.reduce((a, b) => a + b, 0) + game.target) %
        VALID_HASH_CHARS.length
    ];

  // console.log("convertHashToGame", game, checksum, checksumCorrect);
  if (checksumCorrect !== checksum) return false;
  return game;
};
